var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable no-nested-ternary */
// single pagination button component
import React from 'react';
import cn from 'classnames';
export const btnType = ['pager', 'size'];
const PageButton = (_a) => {
    var { type = 'pager', buttonId, children, srDescription, active = false, ariaLabel, disabled = false, className, onClick } = _a, props = __rest(_a, ["type", "buttonId", "children", "srDescription", "active", "ariaLabel", "disabled", "className", "onClick"]);
    /**
     * Check if the button is disabled first before passing the event up
     */
    const onClickWithCheck = e => {
        if (disabled)
            e.preventDefault();
        else {
            onClick && onClick(e);
        }
    };
    return (React.createElement("li", null,
        React.createElement("a", Object.assign({ id: buttonId, href: "/#", onClick: onClickWithCheck, className: cn(type === 'pager' && `cb-btn cb-btn-square cb-btn-greyscale`, disabled && 'cb-disabled', active && `cb-active`, className), "aria-current": active || undefined, "aria-live": active ? 'polite' : undefined, "aria-disabled": disabled || undefined, "aria-label": ariaLabel || undefined, tabIndex: disabled ? -1 : undefined }, props),
            type === 'pager' && React.createElement("span", { className: "sr-only" }, active ? 'page ' : srDescription),
            type === 'size' && React.createElement("span", { className: "sr-only" }, "Show "),
            children,
            type === 'size' && React.createElement("span", { className: "sr-only" }, srDescription || 'records per page'))));
};
export default PageButton;
//# sourceMappingURL=PageButton.js.map